<r247-nav-bar></r247-nav-bar>
<div class="row mt-5">
    <div class="col-12 text-center"><h1>Application is currently running in <strong>{{mode}}</strong> mode.</h1></div>
</div>
